// features/dashboard/dashboardApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: 'https://api.codebondingworkforce.com/api',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: (builder) => ({
    getDashboardData: builder.query({
      query: () => '/admin-panel/dashboard',
    }),
    getUserRechargeHistory: builder.query({
      query: ({ search, name, status, page = 1, limit = 5 }) => ({
        url: '/mobile-recharge/admin/history-for-user',
        params: { search, name, status, page, limit }
      }),
    })
  })
});

export const { 
  useGetDashboardDataQuery,
  useGetUserRechargeHistoryQuery 
} = dashboardApi;